import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

const translationEN = require("./locales/en/translation.json");
const translationUA = require("./locales/ua/translation.json");
const translationPL = require("./locales/pl/translation.json");
const translationRU = require("./locales/ru/translation.json");

const resources = {
  en: { translation: translationEN },
  ua: { translation: translationUA },
  pl: { translation: translationPL },
  ru: { translation: translationRU },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: "en",
    interpolation: { escapeValue: false },
  });

export default i18n;
